/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  util.ts
 *
 * Project Title :  Checkout
 *
 * Description    :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Madhu Gali (H175591)
 *
 * @Date         : Dec 12, 2019
 *
 * @Version      : Version 1.0
 *
 * By            	: Madhu Gali (H175591)
 * On            	: Dec 12, 2019
 * Description   	: ASDS-584
 *
 * By            : Madhu Gali - H175591
 * On            : Jan 10, 2019
 * Description   : ASDS-2152
 *
 * By            : Madhu Gali - H175591
 * On            : Feb 05, 2020
 * Description   : ASDS-2271
 *
 * By            : H224423
 * On            : Apr 03 2020
 * Description   : ASDS-2190 - API error handling changes
 *
 *
 * By            : E807958
 * On            : Mar 30, 2020
 * Description   : ASDS-1763
 *
 ******************************************************************************/
import {
  registeredDomains,
  envConstants,
  StandardEnvironments
} from '../modules/checkout/constants/server-constants';
import CheckoutConstants, { CheckoutServiceURL }
  from 'modules/checkout/constants/checkout-constants';
import { removeSessionStorage } from 'config/sessionStorage';

/**
 * This is a gloabl variable, which gets assigned when called for the first time.
 * On manual page refresh, this gets assigned to "" and gets initialized
 */
export let environment = "";

export function isDebugEnabled() {
  return getProperty(CheckoutConstants.APP_DEBUG_ENABLE);
}

/**
 * @author H175591
 * @param resp
 * @description This method retrieves the values and creates user session object
 */
export function constructUserSessionObj(resp): UserSessionInf {
  const userSessionObj: UserSessionInf = {
    code: resp["code"],
    access_token: resp["access_token"],
    token_type: resp["token_type"],
    expires_in: resp["expires_in"],
    customer_sub: resp['customer_sub'],
    id_token: resp["id_token"],
    scope: resp["scope"],
    refresh_token: resp["refresh_token"]
  };
  return userSessionObj;
}

export interface UserSessionInf {
  code: string;
  access_token: string;
  token_type: string;
  expires_in: number;
  customer_sub: string;
  id_token: string;
  scope: string;
  refresh_token: string;
}

export interface AccessTokenInf {
  access_token: string;
  token_type: string;
  expires_in: number;
  id_token: string;
  scope: string;
  refresh_token: string;
}

export interface AccessCodeInf {
  code: string;
  scope: string;
  state: number;
}

/**
 * @author: H175591
 * @param variable
 * @description: This method checks if the passed parameters are undefined and returns true or false based on the
 * condition.
 */
export function isValueUndefined(variable): boolean {
  let retType = false;
  if (variable === undefined) {
    retType = true;
  }
  return retType;
}

/**
 * @param obj - Any object
 * @description This method checks whether an object is assigned {} as value
 */
export function isEmptyObject(obj): boolean {
  let isEmpty: boolean = true;
  if (obj) {
    isEmpty = Object.keys(obj).length === 0 && obj.constructor === Object;
  }
  return isEmpty;
}
/**
 * @author: H175591
 * @param response
 * @returns {null}
 * @description
 */
export function getDataFromResponse(response) {
  return isValueUndefined(response) ? null : response.data || null;
}

export function getAccessToken(): string {
  /**
   * APU Phase 3 - Pen testing fix - To remove access token from local storage
   */
  // let accessToken = "";
  // try {
  //   const localStoreSessionObj: any = localStorage.getItem(
  //     "checkoutInLocalStorage"
  //   );
  //   if (localStoreSessionObj != null) {
  //     let jsonStr = JSON.parse(localStoreSessionObj);
  //     const localStorageValuesObj = constructUserSessionObj(jsonStr);
  //     console.log("localStorageValuesObj ", localStorageValuesObj);
  //     accessToken = `${localStorageValuesObj.token_type} ${localStorageValuesObj.access_token}`;
  //   }
  // } catch (error) {
  //   console.error(error);
  // }
  // return accessToken;
  let accessToken = "";
  try {
    const sessionStoreSessionObj: any = sessionStorage.getItem(
      "checkoutInLocalStorage"
    );
    if (sessionStoreSessionObj != null) {
      let jsonStr = JSON.parse(sessionStoreSessionObj);
      const sessionStorageValuesObj = constructUserSessionObj(jsonStr);
      console.log("sessionStorageValuesObj ", sessionStorageValuesObj);
      accessToken = `${sessionStorageValuesObj.token_type} ${sessionStorageValuesObj.access_token}`;
    }
  } catch (error) {
    console.error(error);
  }
  return accessToken;
}

/**
 * @author: H175591
 * @param variable
 * @description: This method returns the value of the property value.
 */
export function getProperty(variable): string {
  return envConstants[`${environment}`][variable];
}

/**
 * @author: Madhu Gali
 * @description: This method evaluates the current environment based on the window URL.
 * @param url
 */
export function evaluateCurrentEnv(url: string) {
  const response = registeredDomains.find(e =>
    url.toLocaleLowerCase().startsWith(e.url.toLocaleLowerCase())
  );
  environment = response ? response.env : StandardEnvironments.ut;
}

function removeLocalStorage() {
  // localStorage.removeItem("checkoutInLocalStorage"); APU Phase 3 - Pen testing fix - To remove access token from local storage
  sessionStorage.removeItem("checkoutInLocalStorage");
}

export function removeBrowserStorage() {
  removeLocalStorage();
  const stateRef: string[] = ["state", "PreviousPath", "orderDetails"];
  removeSessionStorage(stateRef);
}

export function handleUnauthorizedUser() {
  removeBrowserStorage();
  window.location.href = getProperty(CheckoutServiceURL.JOULE_REDIRECT_URL);
}